export default "__VITE_ASSET__whgYc7do__"